import steps from './steps';
import buildConfig from './buildConfig';
import * as configs from './configs';
import { questionsData } from './questionsData';
import useResolvedConfig from '../hooks/useResolvedConfig';
import {
  isOnboardingNameVariantB,
  moveNameStepForVariantB,
} from '../utils/scripts/onboardingNameAbTest';
import { useAppStore, useQuestionsStore } from '../store';

// Single source of truth for the survey-engine bootstrap. Called from App's mount
// effect (normal SPA boot) and from the pre-render hydration path BEFORE
// hydrateRoot — so React's very first render already sees the engine in exactly
// the state the captured markup was rendered with. Idempotent: does nothing when
// the steps list is already set up.
//
// rebuild: true пересобирает список шагов посреди воронки (не трогая ответы) и
// оставляет пользователя на текущем шаге — нужно AB-тесту p20v1_onboarding_name,
// когда группа B назначается на шаге customV2_gender.
//
// Returns the name of the flow's first step.
export default function setupSurvey({ rebuild = false }: { rebuild?: boolean } = {}): string {
  const appState = useAppStore.getState();
  const configName = appState.config;
  const configToApply = useResolvedConfig(configName);
  const alreadySetUp = !!appState.list;

  if (!alreadySetUp) {
    useQuestionsStore.getState().setup({
      questionsData,
      predifinedAnswers: undefined,
    });
  }

  if (!alreadySetUp || rebuild) {
    const builtConfig = buildConfig({
      config: configToApply,
      configName,
      age: appState.initialAge,
      role: undefined,
    });

    steps.setup({
      // AB-тест p20v1_onboarding_name: в варианте B шаг customV2_name идёт
      // после statement_strong_bond.
      stepsConfig: isOnboardingNameVariantB() ? moveNameStepForVariantB(builtConfig) : builtConfig,
      currentStep: alreadySetUp ? (appState.currentStep as string) : configToApply[0].name,
      stepsDetails: (configs as unknown as { stepsDetails: Record<string, Record<string, unknown>> }).stepsDetails,
    });
  }

  return configToApply[0].name;
}
